module.exports = __webpack_public_path__ + "static/media/lite-demo-wx-prod.68b916f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/lite-demo-wx-prod.jpg
// module id = 343
// module chunks = 0